import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './ProductBenefits.style';

function ProductBenefits({ benefits }) {
  if (!benefits?.length) {
    return null;
  }

  return (
    <Styled.ProductBenefitsList gap={1}>
      {benefits.map((benefit) => (
        <Stack key={benefit.label} direction="row" alignItems="flex-start" gap={1}>
          <Styled.ProductBenefitsCheckIcon />
          <Box>
            <Text size="sm" weight="bold">
              {benefit.label}
            </Text>
            {benefit.description && (
              <Text size="sm" color="secondary">
                {benefit.description}
              </Text>
            )}
          </Box>
        </Stack>
      ))}
    </Styled.ProductBenefitsList>
  );
}

ProductBenefits.propTypes = {
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
  ),
};

export default ProductBenefits;
